<div #popup class=" mat-dialog-edition-form" appDraggable>
    <div class="popup-header d-flex justify-content-between align-items-center">
      <h2 class="title mx-auto text-center w-100 fs-6">
       {{ 'RECORD.EDIT_NOTES' | translate }}
      </h2>
      <button type="button" class="btn-close ms-auto p-2" data-bs-dismiss="modal" aria-label="Close"
        (click)="onCancel()"></button>
    </div>
    <div class="popup-content">
      <form class="form" id="ngForm">
        <div class="justify-content-between mt-4">
          <div class="row-item-width-100  input-container d-flex">
            <label class="input-label">{{ 'RECORD.NOTE' | translate }} 1</label>
            <textarea #inputString  [(ngModel)]="note1" [ngModelOptions]="{standalone: true}" placeholder="Description"
            class="text-area"  style="width:100%;" rows="3">
            </textarea>
            
          </div>
          <div class="row-item-width-100  input-container d-flex">
            <label class="input-label">{{ 'RECORD.NOTE' | translate }} 2</label>
            <textarea #inputString [(ngModel)]="note2" [ngModelOptions]="{standalone: true}" placeholder="Description"
            class="text-area"  style="width:100%;" rows="3">
            </textarea>
            
          </div>
          <div class="row-item-width-100  input-container d-flex">
            <label class="input-label">{{ 'RECORD.NOTE' | translate }} 3</label>
            <textarea [(ngModel)]="note3" [ngModelOptions]="{standalone: true}" placeholder="Description"
            class="text-area"  style="width:100%;" rows="3">
            </textarea>
            
          </div>
        </div>
      </form>
    </div>
    <div class="popup-footer">
      <button class="secondary-button popup-secondary-button" (click)="onCancel()">{{ 'BUTTONS.CANCEL' | translate }}</button>
      <button class="primary-button popup-primary-button" (click)="onConfirm()"  type="submit">{{ 'BUTTONS.CONFIRM' | translate }}</button>
    </div>
  </div>